"use client";

import { useEffect } from "react";
import { installStaleHardNavigation } from "@/lib/virtualspace/stale-hard-navigation";

/**
 * Turns in-app link clicks into full page loads once this tab is out of
 * date, so a stale tab recovers on the customer's next click instead of
 * staying stuck under the reload banner. See `stale-hard-navigation.ts`.
 */
export function StaleHardNavigation() {
  useEffect(() => installStaleHardNavigation(), []);
  return null;
}
